import React from 'react';
import './IntroPage.css';

function IntroPage() {
  return (
    <div className="intro-page-body">
      <div className="intro-text">
        <h1 className="intro-heading-text">Hey, I'm Miiyu.</h1>
        <h2 className="intro-subheading-text">
          An Electrical Engineering Student
        </h2>
        <h4 className="intro-helper-text">(who also enjoys coding)</h4>
      </div>
    </div>
  );
}

export default IntroPage;
